import * as yup from 'yup';

//TODO: Need to update this
export const packageDetailSchema = yup.object().shape({
  packages: yup
    .array()
    .required()
    .of(
      yup.object().shape({
        id: yup.string().required(),
        price: yup
          .number()
          .required()
          .typeError('Price must be a number')
          .positive('Price must be greater than zero')
          .required('Price is required'),
        // totalTickets: yup.number().when('$isResourcesLinkedToVenue', {
        //   is: (val: boolean) => !val,
        //   then: schema => schema.required(),
        //   otherwise: schema => schema.transform(val => undefined)
        // }),
        resources: yup
          .object({
            count: yup
              .number()
              .transform(value => (isNaN(value) ? undefined : value))
              .when('$isResourcesLinkedToVenue', {
                is: (val: boolean) => !val,
                then: schema => schema.required('Number of tickets is required'),
                otherwise: schema => schema.transform(val => undefined)
              })
          })
          .when('$isResourcesLinkedToVenue', {
            is: (val: boolean) => !val,
            then: schema => schema.required(),
            otherwise: schema => schema.transform(val => undefined)
          }),
        availableTickets: yup.number().when('$isResourcesLinkedToVenue', {
          is: (val: boolean) => !val,
          then: schema => schema.required().min(0, 'Available Tickets Cannot be negative'),
          otherwise: schema => schema.transform(val => undefined)
        }),
        discount: yup
          .number()
          .min(0, 'Discount should be greater than 0')
          .max(100, 'Discount should be less than 100')
      })
    )
});

export type VenueCardFormData = yup.InferType<typeof packageDetailSchema>;
